import React, { useEffect, useState } from "react";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Strings from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Button, Col, Divider, List, Row, Space } from "antd";
import PageContainer from "../layout/PageContainer";

import styles from "./Main.module.css";
import { useNavigate } from "react-router-dom";
import { KeyOutlined } from "@ant-design/icons";

function DigitalKeyList() {
    const navigate = useNavigate();
    const [shareCars, setShareCars] = useState<Array<Types.CarSharerDto>>([]);

    useEffect(() => {
        requestGetShareCars();
    }, []);

    const requestAxiosGetShareCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.CAR_SHARERS_URL, { params: { shareType: "RENT" } });
        return response.data;
    };

    const {
        loading: loadingGetShareCars,
        error: errorGetShareCars,
        data: resultGetShareCars,
        execute: requestGetShareCars,
    } = useAsyncAxios(requestAxiosGetShareCars);

    useEffect(() => {
        if (resultGetShareCars === null) return;
        console.log("resultGetShareCars", resultGetShareCars);
        setShareCars(resultGetShareCars.carSharers);
    }, [resultGetShareCars]);

    useEffect(() => {
        if (errorGetShareCars === null) return;

        console.log("errorGetShareCars", errorGetShareCars);
    }, [errorGetShareCars]);

    const goToController = (shareCar: Types.CarSharerDto) => {
        navigate(Common.PAGE_DIGITALKEY_CONTROL + "/" + shareCar.carSharerId);
    };

    return (
        <PageContainer>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Space direction="vertical" size={10} style={{ width: "100%" }}>
                    <Divider className={styles.subTitle} orientation="left">
                        <span>렌트 중인 차량</span>
                    </Divider>
                    <List
                        dataSource={shareCars}
                        renderItem={(item) => {
                            return (
                                <List.Item>
                                    <Row style={{ width: "100%" }} align="middle" justify="space-between">
                                        <div>
                                            {item.carOwner?.car?.carType?.typeName}_{item.carOwner.car.carNumber}
                                            <div>
                                                {item.user.name}_{item.user.phone.substring(item.user.phone.length - 4, item.user.phone.length)}
                                            </div>
                                        </div>
                                        <Button onClick={() => goToController(item)}>
                                            <KeyOutlined />
                                        </Button>
                                    </Row>
                                </List.Item>
                            );
                        }}
                    />
                </Space>
            </Space>
        </PageContainer>
    );
}

export default DigitalKeyList;
